import { render, staticRenderFns } from "./partnerGuidelines.vue?vue&type=template&id=5a414224"
import script from "./partnerGuidelines.vue?vue&type=script&lang=js"
export * from "./partnerGuidelines.vue?vue&type=script&lang=js"
import style0 from "./partnerGuidelines.vue?vue&type=style&index=0&id=5a414224&prod&lang=less&scpoed=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports